import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getRewardsSummary } from '../../util/api';
import { storableError } from '../../util/errors';
import { storePagehopReferralCode } from '../../util/pagehopReferral';

// ================ Thunks ================ //

export const fetchRewardsSummaryThunk = createAsyncThunk(
  'RewardsPage/fetchRewardsSummary',
  (_, { rejectWithValue }) => getRewardsSummary().catch(e => rejectWithValue(storableError(e)))
);

// ================ Slice ================ //

const initialState = {
  summary: null,
  fetchInProgress: false,
  fetchError: null,
};

const rewardsPageSlice = createSlice({
  name: 'RewardsPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchRewardsSummaryThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchError = null;
      })
      .addCase(fetchRewardsSummaryThunk.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.summary = action.payload;
      })
      .addCase(fetchRewardsSummaryThunk.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchError = action.payload || null;
      });
  },
});

export default rewardsPageSlice.reducer;

// ================ Load data ================ //

/**
 * Loads the signed-in member's private rewards summary. It is browser-only (never server rendered,
 * never cached into SSR state) and skipped for signed-out visitors, who see the public program.
 * On /refer/:code it also remembers the invitation for a later signup on this browser.
 */
export const loadData = params => (dispatch, getState) => {
  if (typeof window === 'undefined') return Promise.resolve();
  const isAuthenticated = !!getState().auth?.isAuthenticated;
  if (params?.code && !isAuthenticated) {
    storePagehopReferralCode(params.code);
  }
  return isAuthenticated ? dispatch(fetchRewardsSummaryThunk()) : Promise.resolve();
};
